import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Stack } from "@mui/material";
import CustomTextField from "../commoncomponents/CustomTextField";
import ComponentHeader from "../commoncomponents/ComponentHeader";
import { useDispatch, useSelector } from "react-redux";
import { updateWorkOrderStatus } from "../../redux/actions/workOrderActionTypes";
import { useLocation } from "react-router-dom";
import { mandatoryFields } from "../../redux/actions/assetActions";
import ScmRepositry from "../../api/repositories/scmRepository";
import ScmBottomButtonsforWorkOrder from "./ScmBottomButtonsforWorkOrder";
import CustomAlert from "../userlocationcomponents/CustomAlert";
import { processingPercentageValue, statusList } from "../../utility/message";


const ScmCostInfo = ({ setPage, page, buttonAttributes }) => {

    //prop value that holds all details about current page,buttons,header,etc., refer AssetMain.jsx for more info
    const findHeaderContent = buttonAttributes.find(
        (item) => item.currentPageName === page
    );

    const dispatch = useDispatch();
    const location = useLocation();
    const basicDetails = useSelector((state) => state.workOrderBasicDetails);
    const assetCategoryType = useSelector((state) => state?.serviceType);
    const status = useSelector((state) => state?.workOrderStatus?.status);
    const processingPercentage = useSelector((state) => state?.workOrderStatus?.percentage);
    const completionInfoData = basicDetails?.completionInfo || {};
    const costInfo = basicDetails?.completionInfo?.costInfo || {};
    const viewmode = location.state?.viewmode;
    const totalSparePartCost = basicDetails?.partReplacementRows?.reduce((acc, part) => acc + (part.partCost || 0), 0) || 0;
    const serviceType = assetCategoryType?.assetType === "fem" ? "fem" : "bem";
    const categoryType = assetCategoryType?.category;
    // const disableFields = categoryType === "Scheduled" ? true : false;
    const setOutsourceDetails = basicDetails?.vendorField === false ? false : true;

    const [costInfoData, setCostInfoData] = useState(costInfo || {});
    const [errorDialog,setErrorDialog] = useState(false);
    const [errorDialogMssg,setErrorDialogMssg] = useState("");

    const statusMapping = {
      "Open": 1,
      "In Progress": 3,
      "Completed": 4,
      "Closed": 5,
      "Cancelled": 6
    };
  
    // Map the current status to the corresponding number
    const mappedStatus = statusMapping[status] || null; 

    const handleOnchange = (value, name) => {
        const formatNumericValue = (value, previousValue) => {
            if (value === "") return ""; // Allow empty input
            if (/^\d*\.?\d*$/.test(value)) { // Allow only valid numeric input
              if (previousValue === "0.00") return value; // Replace `0.00` entirely with the user's input
        
              // If the input is purely zeros or starts with zeros and a decimal
              if (/^0+(\.0*)?$/.test(value)) {
                return "0"; // Keep it as "0" for clarity
              }
        
              // Remove leading zeros for integers
              if (!value.includes(".")) {
                return value.replace(/^0+/, "") || "0"; // Keep "0" if the result becomes empty
              }
        
              // If the input contains a decimal like "0.00454544"
              const [integerPart, decimalPart] = value.split(".");
              if (Number(integerPart) === 0) {
                return decimalPart ? `0.${decimalPart.replace(/^0+/, "")}` : "0."; // Retain "0." for clarity
              }
        
              // Default valid case
              return value.replace(/^0+/, ""); // Remove leading zeros
            }
        
            return previousValue; // Retain the previous valid value if input is invalid
          };

          

       setCostInfoData((previous) => {
        let updatedValue = value;
      
          // Apply formatting for specific fields
          if (["breakDownCost", "ppmCostByPurchaseOrder", "ppmCostByContract","totalSparePartCost","totalWorkorderCost"].includes(name)) {
            updatedValue = formatNumericValue(value, previous[name]);
          }
            const updatedData = {
                ...previous,
                [name]: updatedValue,
            };

            // Calculate totalWorkorderCost for specific fields
            const parsedValue = parseFloat(updatedData[name]) || 0;
            const parsedTotalSparePartCost = parseFloat(totalSparePartCost) || 0;

            if (name === "breakDownCost") {
                const breakDownCost = parseFloat(updatedData?.breakDownCost);
                const totalCost = breakDownCost + parseFloat(totalSparePartCost) || 0;
                updatedData.totalWorkorderCost = totalCost || updatedData.breakDownCost;
            };

            if (name === "breakDownCost") {
                updatedData.totalWorkorderCost = parsedValue + parsedTotalSparePartCost;
            } else if (name === "ppmCostByPurchaseOrder") {
            updatedData.totalWorkorderCost = parsedValue + parsedTotalSparePartCost;
            } else if (name === "ppmCostByContract") {
            updatedData.totalWorkorderCost = parsedValue + parsedTotalSparePartCost;
            }

            return updatedData;
        });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        let checkFieldName = serviceType === "fem" ? "Fem" : "Bem";
        const acceptedById = basicDetails?.assessments?.respondedBy?.id || ""
        const APIPayload = {
            rootcause: completionInfoData?.rootCause || "",
            completedbyempid: completionInfoData?.completionBy?.id || "",
            startdate: completionInfoData?.startDateandTime || "",
            enddate: completionInfoData?.endDateandTime || "",
            acceptedbyid: completionInfoData?.respondedBy?.id || acceptedById || "",
            isassetreqnotavail: completionInfoData?.isassetreqnotavail || false,
            actiontaken: completionInfoData?.actionTaken || "",
            downtimehours: completionInfoData?.downTimeHours || "",
            sparepartscost: totalSparePartCost || "",
            ppmcost: costInfoData?.ppmCostByPurchaseOrder || "",
            ppmcostpurorderno: costInfoData?.ppmCostByPurchaseOrder || "",
            contractppmcost: costInfoData?.ppmCostByContract || "",
            contractrefno: costInfoData?.contractReferenceNumber || "",
            breakdowncost: costInfoData?.breakDownCost || "",
            breakdowncostpurorderno: costInfoData?.poNumber || "",
            totalwocost: costInfoData?.totalWorkorderCost || "",
            id: completionInfoData?.id || "",
            [`${checkFieldName}schcorrectivemaintenanceheaderId`]: basicDetails?.id || "",
            authorizedbyid:basicDetails?.authorizedbyid || "",
            authorizeddate:basicDetails?.AuthorizedbyDate || ""
        };

        if (processingPercentage > 90 && !viewmode && mappedStatus !==6 && mappedStatus !==7) {
            const updateCompletionInfo = await ScmRepositry.updateCompletionInfo(serviceType, completionInfoData?.id, APIPayload);
            
            if (updateCompletionInfo?.id) {
                dispatch({ type: "CREATE_COST_INFO", payload: { ...costInfoData, id: updateCompletionInfo?.id } });
                setPage("Authorization & Summary");
                dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
            } else if (updateCompletionInfo?.response?.data?.status >= 405){
                setErrorDialog(true);
                setErrorDialogMssg("An unexpected error occurred while processing your request.")
            }

        } else if ((mappedStatus === 4 && processingPercentage > 90) || mappedStatus === 5) {
            const updateCompletionInfo = await ScmRepositry.updateCompletionInfo(serviceType, completionInfoData?.id, APIPayload);
            
            if (updateCompletionInfo?.id) {
                dispatch({ type: "CREATE_COST_INFO", payload: { ...costInfoData, id: updateCompletionInfo?.id } });
                setPage("Authorization & Summary");
                dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
            } else if (updateCompletionInfo?.response?.data?.status >= 405){
                setErrorDialog(true);
                setErrorDialogMssg("An unexpected error occurred while processing your request.")
              }
        } else if (viewmode == true || mappedStatus === 6 || mappedStatus === 7) {
            dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
            setPage("Authorization & Summary");
        }
        else {
            const statusId = basicDetails?.assessments?.repairType === "Outsource" ? statusList?.completedOutsource?.id : statusList?.completed?.id //To get the status ID
            const updateCompletionInfo = await ScmRepositry.updateCompletionInfo(serviceType, completionInfoData?.id, APIPayload);
            
            if (updateCompletionInfo?.id) {
                dispatch({ type: "CREATE_COST_INFO", payload: { ...costInfoData, id: updateCompletionInfo?.id } });
                await ScmRepositry.workorderStatusValue(serviceType, basicDetails?.id, statusId, processingPercentageValue?.costInfo);
                dispatch(updateWorkOrderStatus("STATUS_CHANGES", { status: status, percentage: processingPercentageValue?.costInfo }));
                setPage("Authorization & Summary");
                dispatch(mandatoryFields(false, "UPDATE_MANDATORY_REQUIRED_ENABLED"));
            } else if (updateCompletionInfo?.response?.data?.status >= 405){
                setErrorDialog(true);
                setErrorDialogMssg("An unexpected error occurred while processing your request.")
              }

        };

    };

    
    useEffect(() => {
        // Initial calculation when the component mounts or values change
        const breakDownCost = parseFloat(costInfoData.breakDownCost) || 0;
        const ppmCostByPurchaseOrder = parseFloat(costInfoData.ppmCostByPurchaseOrder) || 0;
        const ppmCostByContract = parseFloat(costInfoData.ppmCostByContract) || 0;
        const totalSparePartCosts = parseFloat(totalSparePartCost) || 0;

        // Update total cost with initial or current values
        const totalCost = breakDownCost + ppmCostByPurchaseOrder + ppmCostByContract + totalSparePartCosts;

        setCostInfoData((prevData) => ({
            ...prevData,
            totalWorkorderCost: totalCost,
            totalSparePartCost:totalSparePartCosts

        }));
    }, [costInfoData.breakDownCost, costInfoData.ppmCostByPurchaseOrder, costInfoData.ppmCostByContract, totalSparePartCost]);

    const handleCloseErrRequestDialog = () => {
		setErrorDialog(false);
		setErrorDialogMssg("");
	};
	
	const handleConfirmErrRequestDialog = (e) => {
		e.preventDefault();
		setErrorDialog(false);
		setErrorDialogMssg("")
	};


    return (
        <>
            <ComponentHeader
                mainHeader={findHeaderContent?.mainHeader}
                subHeader={findHeaderContent?.subHeader}
                secondSubHeaderAndDate={findHeaderContent?.secondSubHeaderAndDate}
            />
            <Box >
                <form style={{ position: "relative" }} onSubmit={handleSubmit} noValidate>
                    <Stack direction={'row'} alignItems={'center'} gap={1.5}>
                        <Typography m={0} variant='title2' color={'text.primary'} fontWeight={600}>{basicDetails?.schcorrectiveno || ""}</Typography>
                    </Stack>
                    <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>

                        {/* {!disableFields && (
                            <Grid container spacing={2}>
                                <Grid item xs={6} md={4.5} sm={6}>
                                    <CustomTextField
                                        label="Breakdown Cost in RM (by purchase order)"
                                        id="breakDownCost"
                                        name="breakDownCost"
                                        value={costInfoData?.breakDownCost}
                                        onChange={handleOnchange}
                                        placeholder={"0.00"}
                                        disabled={viewmode}
                                        autoFocus
                                        textAlign="right"
                                        onlyNumbers={true}
                                        numbersLength={13}
                                        allowDecimal={true}

                                    />
                                </Grid>
                                <Grid item xs={6} md={4.5} sm={6}>
                                    <CustomTextField
                                        label="PO Number"
                                        id="poNumber"
                                        name="poNumber"
                                        onChange={handleOnchange}
                                        value={costInfoData?.poNumber}
                                        placeholder={"Enter PO Number"}
                                        disabled={viewmode}
                                    />
                                </Grid>
                            </Grid>
                        )} */}
                    </Box>
                    <Box mb={2}>
                        {setOutsourceDetails === false && (<Grid container spacing={2}>
                            <Grid item xs={6} md={4.5} sm={6}>
                                <CustomTextField
                                    label="PPM Cost in RM (by purchase order)"
                                    id="ppmCostByPurchaseOrder"
                                    name="ppmCostByPurchaseOrder"
                                    onChange={handleOnchange}
                                    value={costInfoData?.ppmCostByPurchaseOrder}
                                    placeholder={"0.00"}
                                    disabled={viewmode}
                                    textAlign="right"
                                    onlyNumbers={true}
                                    numbersLength={13}
                                    allowDecimal={true}
                                />
                            </Grid>
                            <Grid item xs={6} md={4.5} sm={6}>
                                <CustomTextField
                                    label="PO Number"
                                    id="poNumberByPurchaseOrder"
                                    name="poNumberByPurchaseOrder"
                                    onChange={handleOnchange}
                                    placeholder={"Enter PO Number"}
                                    value={costInfoData?.poNumberByPurchaseOrder}
                                    disabled={viewmode}
                                />
                            </Grid>
                        </Grid>
                        )}
                    </Box>
                    <Box mb={2}>
                        {setOutsourceDetails === true && (<Grid container spacing={2}>
                            <Grid item xs={6} md={4.5} sm={6}>
                                <CustomTextField
                                    label="PPM Cost in RM (by Contract)"
                                    id="ppmCostByContract"
                                    name="ppmCostByContract"
                                    onChange={handleOnchange}
                                    placeholder={"0.00"}
                                    value={costInfoData?.ppmCostByContract}
                                    disabled={viewmode}
                                    textAlign="right"
                                    onlyNumbers={true}
                                    numbersLength={13}
                                    allowDecimal={true}
                                />
                            </Grid>
                            <Grid item xs={6} md={4.5} sm={6}>
                                <CustomTextField
                                    label="Contract Reference Number"
                                    id="contractReferenceNumber"
                                    name="contractReferenceNumber"
                                    onChange={handleOnchange}
                                    placeholder={"Enter CR Number"}
                                    value={costInfoData?.contractReferenceNumber}
                                    disabled={viewmode}
                                />
                            </Grid>
                        </Grid>)}
                    </Box>
                    <Box mb={2}>
                        <Grid container spacing={2}>
                            <Grid item xs={6} md={4.5} sm={6}>
                                <CustomTextField
                                    label="Spare Part Cost in RM (Link with inventory Submodule)"
                                    id="totalSparePartCost"
                                    name="totalSparePartCost"
                                    onChange={handleOnchange}
                                    value={totalSparePartCost ? parseFloat(totalSparePartCost || 0)?.toFixed(2) : 0}
                                    disabled
                                    textAlign="right"
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box mt={{ xs: 1, md: 2 }} sx={{ marginTop: '0rem' }}>
                        <Typography variant='title2' > Total Work Order Cost</Typography>
                        <Grid container spacing={2}>
                            <Grid item xs={6} md={4.5} sm={6}>
                                <CustomTextField
                                    label="Total WO Cost in RM"
                                    id="totalWorkorderCost"
                                    name="totalWorkorderCost"
                                    onChange={handleOnchange}
                                    value={costInfoData?.totalWorkorderCost ? parseFloat(costInfoData?.totalWorkorderCost || 0)?.toFixed(2) : 0}
                                    disabled
                                    textAlign="right"
                                />
                            </Grid>
                        </Grid>
                    </Box>
                    <Box>
                        <ScmBottomButtonsforWorkOrder page={page} buttonAttributes={buttonAttributes} />
                    </Box>
                </form>
            </Box>

            <CustomAlert
				open={errorDialog}
				onClose={handleCloseErrRequestDialog}
				onConfirm={handleConfirmErrRequestDialog}
				content={errorDialogMssg}
				confirmBtn='OK'
			/>

        </>
    );
};

export default ScmCostInfo;
